#
# enables mixins in backbone views
# events and function list handled separately
# extend mixin from this class, then use applyMixin()
#
export default class BackboneMixin
  @applyMixin: (view) ->
    mixin       = new this
    mixinEvents = mixin.events
    mixinFuncs  = _.omit(mixin.__proto__, "events", "constructor")

    view.events = view.events || {}
    _.extend(view.events, mixinEvents)

    # Add new mixin functions but DO NOT overwrite any that exist in the main view. This allows
    # views to still override mixin functionality
    for name, prop of mixinFuncs
      unless name of view
        view[name] = prop



// WEBPACK FOOTER //
// ./app/javascript/lib/backbone_mixin.js.coffee